import React from 'react';

const TYPEWRITER_WORDS = ['invoices', 'receipts', 'contacts', 'credit notes'];

function useTypewriter(words) {
  const [idx, setIdx] = React.useState(0);
  const [chars, setChars] = React.useState(0);
  const [deleting, setDeleting] = React.useState(false);

  React.useEffect(() => {
    const word = words[idx];
    if (!deleting) {
      if (chars < word.length) {
        const t = setTimeout(() => setChars((c) => c + 1), 90);
        return () => clearTimeout(t);
      }
      const t = setTimeout(() => setDeleting(true), 1600);
      return () => clearTimeout(t);
    }
    if (chars > 0) {
      const t = setTimeout(() => setChars((c) => c - 1), 55);
      return () => clearTimeout(t);
    }
    setDeleting(false);
    setIdx((i) => (i + 1) % words.length);
  }, [chars, deleting, idx, words]);

  return words[idx].slice(0, chars);
}

function SyncMascotIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="4" width="14" height="18" rx="2" fill="#ee734c" opacity="0.15"/>
      <rect x="6" y="4" width="14" height="18" rx="2" stroke="#ee734c" strokeWidth="1.5"/>
      <path d="M10 10h6M10 13.5h6M10 17h4" stroke="#ee734c" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M18 17l3.5 3.5M21.5 17L18 20.5" stroke="#ee734c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="22" cy="22" r="4" stroke="#ee734c" strokeWidth="1.5"/>
      <path d="M22 20v2l1 1" stroke="#ee734c" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function NewOrgEmptyState() {
  const word = useTypewriter(TYPEWRITER_WORDS);

  return (
    <div className="drm-new-org-state">
      <div className="drm-new-org-mascot" aria-hidden="true">
        <SyncMascotIcon />
      </div>
      <h2 className="drm-new-org-heading">
        Getting your{' '}
        <span className="drm-new-org-word">{word}</span>
        <span className="drm-new-org-cursor" aria-hidden="true" />
      </h2>
      <p className="drm-new-org-sub">
        We're syncing your account for the first time. Your dashboard will be ready in a couple of minutes.
      </p>
    </div>
  );
}

export default NewOrgEmptyState;
